
import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);

    const login = (userData) => {
        console.log(userData)
        setUser(userData);
        // Add logic for setting user data in localStorage or sessionStorage if needed
    };

    const logout = () => {
        setUser(null);
        // Clear user data from localStorage or sessionStorage if needed
    };

    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
